import { getCountFromServer, query, where } from 'firebase/firestore'
import type { Identifiable } from '~/models/identifiable'
import { PullService } from './servicePull'
import type { IntakeStatus, PartnerLeadStatus } from '~/models'

export class DealsCountService extends PullService<
  Identifiable,
  Identifiable[]
> {
  private collection

  constructor() {
    super()
    const { collection } = useFirebase()
    this.collection = collection
  }

  public async getCountByStatus(status: IntakeStatus): Promise<number> {
    const collection = this.collection('Deals')

    const countQuery = query(
      collection,
      where('PharmacyStatus', '==', 'intakeGesprek'),
      where('IntakeStatus', '==', status),
    )

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }

  async getCountByPartnerLeadStatus(
    status: PartnerLeadStatus,
  ): Promise<number> {
    const collection = this.collection('Deals')

    const countQuery = query(
      collection,
      where('PartnerLeadStatus', '==', status),
    )

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
